import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const KeyIcon = createSvgIcon(
  <>
    <title>key</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <path
        d="M25,1,12.784,13.154a8.572,8.572,0,1,0,6.061,6.061L21,17V13h4V9h3l3-3V1Z"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="10"
        cy="22"
        data-color="color-2"
        fill="none"
        r="3"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
